var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_Pic",
    "data-name": "Profile Pic",
    transform: "translate(-2514.223 14133.777)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3610",
    "data-name": "Ellipse 3610",
    cx: 80,
    cy: 80,
    r: 80,
    transform: "translate(2514.223 -14133.777)",
    fill: "#304669",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "user",
    d: "M35.113,34.111A15.556,15.556,0,1,0,19.558,18.556,15.556,15.556,0,0,0,35.113,34.111Zm0,7.778A38.83,38.83,0,0,0,4,57.444a38.894,38.894,0,0,0,62.228,0A38.83,38.83,0,0,0,35.113,41.889Z",
    transform: "translate(2559.224 -14091.777)",
    fill: "#1d0b77",
    opacity: 0.25
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfile);
export default __webpack_public_path__ + "static/media/EmptyProfile.39c58911b7ef4c03a3c63802bd1bf10f.svg";
export { ForwardRef as ReactComponent };